export default __webpack_public_path__ + "static/bg_kpcovid19.jpg?9373d18e35fb";